import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import "@/lib/mailboxLock";
import { startBidiFix } from "@/lib/bidiFix";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

startBidiFix();

// Register the PWA service worker (push notifications + installability).
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

// Capture the install prompt early so we can trigger it from a button later.
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__wzInstallPrompt = e;
  window.dispatchEvent(new Event("wz-installable"));
});
window.addEventListener("appinstalled", () => {
  window.__wzInstallPrompt = null;
  window.dispatchEvent(new Event("wz-installed"));
});
